module.exports = __webpack_public_path__ + "img/Inventory_bar 2.8957a291.png";